import DebounceInput from "common/components/DebounceInput/DebounceInput";
import React from "react";
import { FloatLabel } from "primereact/floatlabel";

type CrudFiltersRenderType = "input" | "custom";

export type CrudFilter = {
  name: string;
  label?: string;
  renderType: CrudFiltersRenderType;
  renderComponent?: React.ReactNode;
  className?: string;
};

export interface ICrudFiltersProps {
  filters: CrudFilter[];
  activeFilters?: Record<string, any>;
  setFilter: (name: string, value: any) => void;
  className?: string;
}

function CrudFilters({
  filters,
  activeFilters,
  setFilter,
  className,
}: ICrudFiltersProps) {
  return (
    <div
      className={`crud-filters flex flex-col lg:flex-row gap-4 items-start lg:items-center px-2 ${
        className || ""
      }`}
    >
      {filters.map((filter) => {
        const filterValue = activeFilters?.[filter.name];
        const isActive =
          filterValue !== undefined &&
          filterValue !== null &&
          filterValue !== "" &&
          (!Array.isArray(filterValue) || filterValue.length > 0);

        return (
          <div key={filter.name} className={filter.className}>
            {filter.renderType === "input" ? (
              <FloatLabel>
                <DebounceInput
                  id={filter.name}
                  placeholder=" "
                  // placeholder={filter.label || ""}
                  value={activeFilters?.[filter.name] || ""}
                  onChange={(value: any) => setFilter(filter.name, value)}
                  className={`crud-filter-input p-inputtext ${
                    isActive ? "p-filled" : ""
                  }`}
                />
                <label
                  className={`crud-filter-label ${
                    isActive ? "crud-filter-label-active" : ""
                  }`}
                  htmlFor={filter.name}
                >
                  {filter.label}
                </label>
              </FloatLabel>
            ) : (
              <FloatLabel>
                {React.cloneElement(
                  filter.renderComponent as React.ReactElement,
                  {
                    value: activeFilters?.[filter.name],
                    onChange: (value: any) => setFilter(filter.name, value),
                    className: `crud-filter-input ${
                      isActive ? "p-filled p-inputwrapper-filled" : ""
                    }`,
                  }
                )}
                <label
                  className={`crud-filter-label ${
                    isActive ? "crud-filter-label-active" : ""
                  }`}
                  htmlFor={filter.name}
                >
                  {filter.label}
                </label>
              </FloatLabel>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default CrudFilters;
